import {
  CountryCodes,
  type Home,
  HomeTier,
  LpsDolsSetting
} from '@lmc/ts-common'
import { shallowEqual, useSelector } from 'react-redux'

const useHomeType = () =>
  useSelector((state: { global: { home: Home } }) => {
    const home = state?.global?.home

    const hasOutstandingFeature =
      home?.features?.goals?.enabled ||
      home?.features?.positiveBehaviour?.enabled ||
      false
    const isOutstandingTier = home?.tier === HomeTier.outstanding

    return {
      alreadyHadRotaTrialEnabled: !!home?.rotaTrialDate,
      features: home?.features,
      hasOutstandingFeature,
      hasRota: home?.features?.rota?.enabled || false,
      isDoLSOverride: home?.preferredServiceName === LpsDolsSetting.dols,
      isEmar: home?.features?.eMAR?.enabled || false,
      isFromCanada: home?.countryCode === CountryCodes.ca,
      isFromScotlandOrWales:
        home?.countryCode === CountryCodes.sct ||
        home?.countryCode === CountryCodes.wls,
      isMultiSiteHome: home?.features?.isMultiSiteHome?.enabled || false,
      isOutstanding: isOutstandingTier || hasOutstandingFeature,
      isPro: home?.features?.pro?.enabled || false
    }
  }, shallowEqual)

export default useHomeType
